import React from 'react'
import ReactDOM from 'react-dom'
import { useSpring, animated } from 'react-spring'
import Cards6 from "./Cards_6";
import { NavLink, Link } from "react-router-dom";

const calc = (x, y) => [-(y - window.innerHeight / 2) / 20, (x - window.innerWidth / 2) / 20, 1.1]
const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`

/*<div className="">
<animated.div
        class="card4"
        onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
        onMouseLeave={() => set({ xys: [0, 0, 1] })}
        style={{ transform: props.xys.interpolate(trans) , backgroundImage:  'url("./pictures/images_14.jpg")' }}    
/> 

</div>*/

function Card() {
  const [props, set] = useSpring(() => ({ xys: [0, 0, 1], config: { mass: 5, tension: 350, friction: 40 } }))

  var divStyle = {
    color: 'blue',
    cursor: 'pointer',
  }

  return (
    <div className="">



        <div   id = "signal-report"    className="card-4"   style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}   >
        <br></br>
          <a     id ="Strategy" aria-expanded="false" ><img className=""  width="170px" height="70px" src="./pictures/images_14.jpg"></img><span className="doc-content-title">Proprietary Trading System</span></a>
                            <div className="wrapper_line"></div>

                            <br></br>

                  <p id="page_summary_id" className="page_summary_id">
                  <span>The Interactive Decision-Making System (iDMS) is a proprietary scoring-based trading intelligence engine built upon a structured indicator-state classification framework designed to analyze momentum, reversal behavior, and evolving market regimes across multiple timeframes.</span>
                  <span>Rather than relying on isolated indicator readings, iDMS transforms underlying technical indicators into classified behavioral states that collectively contribute to a dynamic market-scoring environment.</span>
                  <br></br>  
                  <br></br>  

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                  >
                    Learn more ...
                  </NavLink>
                

                  <br></br>  

                  
                  
                  </p>

                  <br></br>
    
                  <Cards6 />
                  <br></br>
        </div>

</div>

  )
};

export default Card; 


